@import '../../../styles/vars.css';

.root {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  padding-top: 8px;
  padding-bottom: 8px;
}

.root.focusVisible {
  background-color: rgba(0, 0, 0, 0.08);
}

.root.selected,
.root.selected:hover {
  background-color: var(--action-selected);
}

.root.disabled {
  opacity: var(--action-disabled-opacity);
}

.container {
  position: relative;
}

.focusVisible {
  background-color: var(--action-focus);
}

.dense {
  padding-top: 4px;
  padding-bottom: 4px;
}

.alignItemsFlexStart {
  align-items: flex-start;
}

.disabled {
}

.divider {
  border-bottom: 1px solid var(--divider);
  background-clip: padding-box;
}

.gutters {
  padding-left: 16px;
  padding-right: 16px;
}

.button {
  transition: background-color 150ms var(--easing-ease-in-out) 0ms;
}

.button:hover {
  text-decoration: none;
  background-color: var(--action-hover);
}

.button.selected:hover {
  background-color: var(--action-selected);
}

@media (hover: none) {
  .button:hover {
    background-color: transparent;
  }

  .button.selected:hover {
    background-color: var(--action-selected);
  }
}

.secondaryAction {
  padding-right: 48px;
}

.selected {
}
